import { TableSessionType } from '../app/Common/Enum/TableSessionType';

export default class Formatter {
    static currencyFormat(num) {
        num = parseFloat(num) || 0
        return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    }

    static readableDate(dateObject) {
        let date = moment(dateObject)
        let diff = moment().diff(moment(date), 'days')

        switch (diff) {
            case 0:
                return lang.today;
            case 1:
                return lang.yesterday;
            default:
                break;
        }


        if (diff == 0) {
            day = lang.today
        } else if (diff == 1) {

        }
        return `${date.format('YYYY-MM-DD')}`
    }

    static readableDateTime(stdDateTime, timeFirst = true) {//yyyy-mm-dd
        let date = moment(stdDateTime)
        let day = date.format('DD MMM YYYY')
        let diff = moment().diff(date, 'days')
        var isToday = date.isSame(moment(), "day");
        if (isToday) {
            day = lang.today
        }
        let time = date.format('LT')
        diff = moment().diff(date, 'minutes')
        if (diff > 0) {
            if (diff < 1) {
                time = lang.just_now
                day = ""
            } else if (diff < 5) {
                let min = lang.min_ago
                time = `${diff} ${min}`
                day = ""
            }
        }
        return timeFirst ? `${time} ${day}` : `${day} ${time}`
    }

    static getOrderMode(tableSessionTypeId) {
        switch (parseInt(tableSessionTypeId)) {
            case TableSessionType.DINE_IN:
                return lang.dine_in
            case TableSessionType.PICKUP:
                return lang.pickup
            case TableSessionType.DELIVERY:
                return lang.delivery
        }
    }

    static getBillStatusToString(status) {
        switch (status) {
            case 0:
                return lang.bill_status_cancelled
            case 1:
                return lang.bill_status_open
            case 2:
                return lang.bill_status_closed
            case 3:
                return lang.bill_status_waiting_for_collection
            case 4:
                return lang.bill_status_cash_on_delivery
        }
        return ""
    }

    static getDateInStandardFormat(date) {
        var dd = String(date.getDate()).padStart(2, '0')
        var mm = String(date.getMonth() + 1).padStart(2, '0')
        var yyyy = date.getFullYear()
        return `${yyyy}-${mm}-${dd}`
    }

    static getMonthString(date) {
        return date.format('MMMM')
    }

    static getDayString(day) {
        switch (day) {
            case 0:
                return "Sun"
            case 1:
                return "Mon"
            case 2:
                return "Tue"
            case 3:
                return "Wed"
            case 4:
                return "Thu"
            case 5:
                return "Fri"
            case 6:
                return "Sat"
            case 7:
                return lang.today
            default:
                return ""
        }
    }
}
